/* eslint-disable jsx-a11y/anchor-is-valid */
import { createPortal } from "react-dom";
import { FaWindowClose } from "react-icons/fa";

const Modal = ({ open, onClose }) => {
  if (!open) return null;
  return createPortal(
    <>
      <div className="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-70 z-40" onClick={onClose}></div>
      <div className="fixed top-[20%] md:top-1/4 flex flex-col items-end rounded-lg bg-slate-300 z-50">
        <FaWindowClose size="26" color="#9333ea" onClick={onClose} className="-mt-px" />
        <div className="px-3 pt-3 w-full">
          <img className="mx-auto h-12 w-auto" src="https://tailwindui.com/img/logos/workflow-mark-purple-600.svg" alt="Workflow" />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Fake placeholder form</h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            This isn't working yet,{" "}
            <a href="#" className="font-medium text-purple-600 hover:text-violet-500">
              perhaps in the future
            </a>
          </p>
        </div>
        <form
          className="mt-8 space-y-6 px-3 pb-6 w-full"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <input type="hidden" name="remember" defaultValue="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-purple-500 focus:border-purple-500 focus:z-10 sm:text-sm"
                placeholder="Email address"
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-purple-500 focus:border-purple-500 focus:z-10 sm:text-sm"
                placeholder="Password"
              />
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300 rounded" />
              <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
                Remember me
              </label>
            </div>

            <div className="text-sm">
              <a href="#" className="font-medium text-purple-600 hover:text-purple-500">
                Forgot your password?
              </a>
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3"></span>
              Nothing will happen
            </button>
          </div>
        </form>
      </div>
    </>,
    document.getElementById("modal")
  );
};

export default Modal;
